import template from 'templates/__notificationBar.tpl';
import Breakpoints from 'helpers/breakpoints';
import { AUTO_CLOSE_TIMEOUT } from '../../helpers/notificationBarConstants';

export default class NotificationBar {
    constructor(options = {}) {
        this._ = null;
        this._closeBtn = null;
        this._timeout = null;
        this._resizeHandler = null;
        this.elHeader = document.querySelector('header').firstElementChild;
        this.autoCloseTimeout = AUTO_CLOSE_TIMEOUT;
        this.visible = false;
        this.closeable = true;
        this.message = '';
        this.success = true;

        // Initializes the component when DOM is loaded
        this.init();
    }

    init() {
        let bodyEl = document.body;
        let notificationBarEl = document.createRange().createContextualFragment(template());

        bodyEl.insertBefore(notificationBarEl, bodyEl.firstElementChild);
        this._ = bodyEl.querySelector('div.notification-bar-wrapper');
        this._closeBtn = this._.querySelector('span.icon.close');
        // Sets click handler for closing button
        this._closeBtn.addEventListener('click', () => this.hideMessage());
    }

    showMessage(message = '', success = false, closeable = true) {
        // Message is visible
        if (this.visible) {
            if (!this.closeable) {
                this.extendAutoHide();
            }
            return false;
        }

        let notificationMsgEl = this._.querySelector('span.notification');
        let notificationBarEl = this._.querySelector('div.notification-bar');
        let classList = notificationBarEl.classList;

        // Sets message
        notificationMsgEl.innerHTML = message;

        // Sets intention of message
        if (success) {
            classList.remove('negative');
            classList.add('positive');
        } else {
            classList.remove('positive');
            classList.add('negative');
        }

        // Sets message to be closable or not
        if (closeable) {
            classList.add('closeable');
        } else {
            classList.remove('closeable');
            this.setAutoHide();
            // Adds event listener for interacting with notification bar
            notificationBarEl.addEventListener('mouseenter', () => clearTimeout(this._timeout));
            notificationBarEl.addEventListener('mouseleave', () => this.setAutoHide());
        }

        // keep top when resizing the window
        this._resizeHandler = () =>
            notificationBarEl.style.setProperty('top', this.calculateTopProperty());
        window.addEventListener('resize', this._resizeHandler);

        // keep notification bar hidden when scrolled
        this._scrollHandler = () => {
            if (window.getComputedStyle(notificationBarEl).visibility === 'visible') {
                this.hideMessage();
            }
        };
        window.addEventListener('scroll', this._scrollHandler);

        // Shows message
        notificationBarEl.style.setProperty('top', this.calculateTopProperty());
        notificationBarEl.classList.remove('invisible');
        this.visible = true;
        this.closeable = closeable;
    }

    hideMessage() {
        let notificationBarEl = this._.querySelector('div.notification-bar');
        notificationBarEl.style.removeProperty('top');
        notificationBarEl.classList.add('invisible');
        this.visible = false;
        // Removes resize event listener
        window.removeEventListener('resize', this._resizeHandler);
    }

    setAutoHide(milliseconds = 4500) {
        this.autoCloseTimeout = milliseconds;
        this._timeout = setTimeout(() => this.hideMessage(), this.autoCloseTimeout);
    }

    extendAutoHide() {
        clearTimeout(this._timeout);
        this.setAutoHide();
    }

    isVisible() {
        return this.visible;
    }

    calculateTopProperty() {
        if (this.isHeaderVisible()) {
            return this.isMobileLandscapeMax() ? '40px' : '56px';
        } else {
            return '0px';
        }
    }

    isHeaderVisible() {
        let computedStyle = window.getComputedStyle(this.elHeader.parentElement);
        return parseInt(computedStyle.getPropertyValue('top')) >= 0;
    }

    isMobileLandscapeMax() {
        let b = new Breakpoints();
        return b.isMobilePortrait() || b.isMobileLandscape();
    }
}
